import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../_metronic/_helpers";
import { Pagination } from "../../_metronic/_partials/controls";

import { getHandlerTableChange } from "../../_metronic/_helpers";
import { PaginationTotalRenderer } from "./PaginationTotalRenderer";


export function TableComponent({
  table,
  setQueryParams,
  queryParams,
  listLoading,
  sizePerPageList = [
    { text: "3", value: 3 },
    { text: "5", value: 5 },
    { text: "10", value: 10 },
  ],
  defaultSorted = [{ dataField: "id", order: "asc" }],
  keyField = 'id',
  rowClasses = (row, rowIndex) => {
    return '';
  }
}) {
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: table.totalCount,
    sizePerPageList: sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber,
    paginationTotalRenderer: PaginationTotalRenderer,
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                rowClasses={ rowClasses }
                bootstrap4
                bordered={false}
                remote
                keyField={keyField}
                data={table.entities === null ? [] : table.entities}
                columns={table.columns}
                defaultSorted={defaultSorted}
                onTableChange={getHandlerTableChange(setQueryParams)}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={table.entities} />
                <NoRecordsFoundMessage entities={table.entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
